import {
  Columns,
  Column,
  Card,
  Stack,
  Box,
  Inline,
  Hidden,
} from 'braid-design-system';
import React, { type ComponentProps, type FC } from 'react';
import * as styles from './styles.css';

export interface TableRowLayoutProps {
  name: JSX.Element;
  manuallyAdded: JSX.Element | null;
  phoneNumber: JSX.Element | null;
  status: JSX.Element;
  mostRecentRole: JSX.Element;
  mostRecentCompanyName: JSX.Element | null;
  mostRecentRoleMobile: JSX.Element;
  mostRecentApplication: JSX.Element;
  previousApplications: JSX.Element;
  relativeApplicationTime: JSX.Element;
  kebab: JSX.Element;
}

export const TableRowLayout: FC<TableRowLayoutProps> = ({
  name,
  manuallyAdded,
  phoneNumber,
  status,
  mostRecentRole,
  mostRecentCompanyName,
  mostRecentRoleMobile,
  mostRecentApplication,
  relativeApplicationTime,
  previousApplications,
  kebab,
}) => {
  const desktopSpacing: ComponentProps<typeof Columns>['space'] = 'small';
  const customBoxColumnMobileSpacingFix: ComponentProps<
    typeof Box
  >['paddingY'] = 'xsmall';

  const mobileStatus = <Hidden above="mobile">{status}</Hidden>;

  return (
    <Card>
      <Columns space={desktopSpacing} align="left" alignY={['top', 'center']}>
        <Box className={styles.contentColumnSection}>
          <Column width="content">
            <Columns
              space={desktopSpacing}
              collapseBelow="tablet"
              alignY="center"
            >
              <Box
                className={styles.nameColumn}
                paddingY={[customBoxColumnMobileSpacingFix, 'none']}
              >
                <Column width="content">
                  <Stack space={['medium', 'small']} align="left">
                    {manuallyAdded ? (
                      <Inline space="small">
                        {manuallyAdded}
                        {mobileStatus}
                      </Inline>
                    ) : (
                      mobileStatus
                    )}
                    {name}
                    {phoneNumber}
                  </Stack>
                </Column>
              </Box>
              <Box className={styles.statusColumn}>
                <Hidden below="tablet">
                  <Column width="content">{status}</Column>
                </Hidden>
              </Box>
              <Box
                className={styles.mostRecentRoleColumn}
                paddingY={[customBoxColumnMobileSpacingFix, 'none']}
              >
                <Hidden above="mobile">
                  <Column>{mostRecentRoleMobile}</Column>
                </Hidden>
                <Hidden below="tablet">
                  <Column width="content">
                    <Stack space="small">
                      {mostRecentRole}
                      {mostRecentCompanyName}
                    </Stack>
                  </Column>
                </Hidden>
              </Box>
              <Box
                className={styles.mostRecentApplicationColumn}
                paddingY={[customBoxColumnMobileSpacingFix, 'none']}
              >
                <Column width="content">
                  <Stack space="small">
                    {mostRecentApplication}
                    {relativeApplicationTime}
                  </Stack>
                </Column>
              </Box>
              <Box
                className={styles.previousAppsColumn}
                paddingTop={['medium', 'none']}
              >
                <Column width="content">{previousApplications}</Column>
              </Box>
            </Columns>
          </Column>
        </Box>
        <Box
          className={styles.overflowMenuColumnSection}
          paddingY={[customBoxColumnMobileSpacingFix, 'none']}
        >
          <Column width="content">{kebab}</Column>
        </Box>
      </Columns>
    </Card>
  );
};
